import { ComponentProps } from 'react';
import { Button } from '@visalex/core';

import cx from 'clsx';

import styles from './CustomRangeSelectListItem.module.scss';

type CustomRangeSelectListItemProps = ComponentProps<typeof Button> & {
  onSelectHandler(): void;
};

export const CustomRangeSelectListItem = ({
  children,
  active,
  onSelectHandler,
  ...props
}: CustomRangeSelectListItemProps) => (
  <li className={cx(styles.item, active && styles['item--active'])}>
    <Button
      theme="default"
      {...props}
      size={props.size || 'sm'}
      onClick={onSelectHandler}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.code === 'Space') {
          onSelectHandler();
        }
      }}
      className={cx(props.className, styles.button)}
    >
      {children}
    </Button>
  </li>
);
